<template>
  <div class="explain2">
    <div class="explain-warpper">
      <h1>识别说明</h1>
      <div class="pic-item">
        <h2>1. 请仔细核对方格中的红色线条分布，不符为假。</h2>
        <h2>2. 请留意每条红线与薄膜边缘相交。</h2>
        <img src="../../assets/images/example01/explain@2x.jpg" alt />
      </div>
    </div>
    <div class="footer">
      <button @click="back">返 回</button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    back: function () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="stylus" scoped>
.explain2 {
  color: #231815;
  position: fixed;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  overflow: auto;

  .explain-warpper {
    min-height: 100%;
    margin-bottom: 2.777778rem;

    h1 {
      font-size: 0.652778rem;
      text-align: center;
      margin: 1.527778rem auto;
      color: #1B92D2;
    }

    .pic-item {
      margin-bottom: 0.833333rem;
      padding: 0 0.8rem;
      text-align: center;

      h2 {
        text-align: left;
        font-size: 0.346667rem;
        line-height: 0.853333rem;
      }

      img {
        margin-top: 1.013333rem;
        width: 3.44rem;
      }
    }
  }

  .footer {
    width: 100%;
    text-align: center;
    margin-top: -5.866667rem;

    button {
      border: none;
      background: transparent;
      color: #1B92D2;
      font-size: 0.5rem;
      border-bottom: 1px solid #1B92D2;
      padding: 0.138889rem;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/example01/explain2.vue